/** @format */

import "../App.css";
import React from "react";
import { Link } from "react-router-dom";

const Footer = ({ loggedin }) => {
  if (!loggedin) {
    return <div></div>;
  }
  return (
    <footer
      id='footer'
      className='footer'
    >
      <div className='container'>
        <div className='row gy-3'>
          <div className='col-lg-6 col-md-6 d-flex'>
            <i className='bi bi-folder icon'></i>
            <div>
              <a href='https://fundacionunam.org/cei/directorio.html'>
                <h4>Directorio</h4>
              </a>
            </div>
          </div>
          <div className='col-lg-6 col-md-6 d-flex'>
            <i className='bi bi-question-square icon'></i>
            <div>
              <a href='#preguntas_frecuentes'>
                <h4>Preguntas Frecuentes</h4>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
